/**
 * Leorix Theme Scripts
 * Base utilities and interactions for Phase A (no Tailwind).
 */

// 1. Global Mode Control Helper
window.toggleStoreMode = () => {
  const currentMode = document.documentElement.getAttribute('data-store-mode') || 'phaseA';
  const nextMode = currentMode === 'phaseA' ? 'phaseB' : 'phaseA';
  document.documentElement.setAttribute('data-store-mode', nextMode);
  localStorage.setItem('leorix_store_mode', nextMode);
  
  // Dispatch a custom event so components can listen and re-render
  document.dispatchEvent(new CustomEvent('leorixStoreModeChanged', { detail: nextMode }));
  return nextMode;
};

document.addEventListener('DOMContentLoaded', () => {
  // Initial State Sync
  const syncStoreMode = () => {
    const savedMode = localStorage.getItem('leorix_store_mode') || 'phaseA';
    document.documentElement.setAttribute('data-store-mode', savedMode);
  };
  syncStoreMode();

  // 3. Simple Toast Helper
  window.showToast = (message) => {
    let toast = document.getElementById('toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  };
});
